// extracted by mini-css-extract-plugin
export default {"container":"Sj-z","freeShip":"Tj-z","privacy":"Uj-z"};